import {
  Sparkles,
  Sun,
  Sunrise,
  Coffee,
  Zap,
  Moon,
  PlayCircle,
  Plug,
  Hand,
  Heart,
  HelpCircle,
  MessageCircle,
  ShieldCheck,
  Clock,
  User,
} from "lucide-react";

/**
 * SectionLabel — unified premium eyebrow.
 * Small blue icon + uppercase mono text + tracking. No disc background.
 * Same look across every section AND the hero badge.
 *
 * Props:
 *   icon: lucide component (default Sparkles)
 *   onDark?: render variant for dark backgrounds
 */
export default function SectionLabel({ icon: Icon = Sparkles, children, onDark = false }) {
  return (
    <div className="inline-flex items-center gap-2.5 mb-5">
      <Icon
        size={12}
        strokeWidth={2.2}
        className="text-[#437DEA]"
      />
      <span
        className={`font-mono text-[11px] tracking-[0.24em] uppercase font-semibold ${
          onDark ? "text-white/70" : "text-[#1A1814]/70"
        }`}
      >
        {children}
      </span>
    </div>
  );
}

export {
  Sparkles,
  Sun,
  Sunrise,
  Coffee,
  Zap,
  Moon,
  PlayCircle,
  Plug,
  Hand,
  Heart,
  HelpCircle,
  MessageCircle,
  ShieldCheck,
  Clock,
  User,
};
